/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */

export type UpdatePersonasDtoPersonasItem =
  (typeof UpdatePersonasDtoPersonasItem)[keyof typeof UpdatePersonasDtoPersonasItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePersonasDtoPersonasItem = {
  artist: "artist",
  producer: "producer",
  band: "band",
  listener: "listener",
  label_rep: "label_rep",
  music_supervisor: "music_supervisor",
  artist_manager: "artist_manager",
  a_and_r: "a_and_r",
  other: "other",
} as const;
